import { createTheme, Theme } from '@mui/material/styles';
import type { ThemeTokens } from './tokens';
import { getShapeRadii } from './tokens';

export const createAppTheme = (tokens: ThemeTokens): Theme => {
    const radii = getShapeRadii(tokens.shape);
    const borderRadius = radii.md;

    return createTheme({
        typography: {
            fontFamily: 'Montserrat, Roboto, Arial, sans-serif',
        },
        palette: {
            primary: {
                main: tokens.primary,
            },
            secondary: {
                main: tokens.secondary,
            },
            info: {
                main: tokens.accent,
            },
            background: {
                default: tokens.background,
                paper: '#ffffff',
            },
            text: {
                primary: tokens.text,
                secondary: tokens.textSecondary,
            },
        },
        shape: {
            borderRadius,
        },
        components: {
            MuiToolbar: {
                styleOverrides: {
                    root: {
                        minHeight: '52px !important',
                    },
                },
            },
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true,
                },
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        minHeight: '48px',
                    },
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: 600,
                        borderRadius: tokens.shape === 'square' ? radii.sm : radii.md,
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    rounded: {
                        borderRadius: tokens.shape === 'square' ? radii.sm : radii.lg,
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderRadius: tokens.shape === 'square' ? radii.sm : radii.lg,
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        '& .MuiOutlinedInput-root': {
                            borderRadius: tokens.shape === 'square' ? radii.sm : radii.md,
                        },
                    },
                },
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        borderRadius: tokens.shape === 'square' ? radii.sm : radii.pill,
                    },
                },
            },
            MuiGrid: {
                styleOverrides: {
                    item: {
                        fontWeight: 500,
                    },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        fontWeight: 500,
                    },
                },
            },
            MuiBottomNavigationAction: {
                styleOverrides: {
                    label: {
                        fontWeight: 600,
                    },
                },
            },
        },
        transitions: {
            create: () => 'none',
        },
    });
};
